import AddCardModal from "@/components/dashboard/modal/AddCardModal";
import AddRecipientsModal from "@/components/dashboard/modal/AddRecipientsModal";
import CardModal from "@/components/dashboard/modal/CardModal";
import CongratulationsModal from "@/components/dashboard/modal/CongratulationsModal";
import PurchasedModal from "@/components/dashboard/modal/PurchasedModal";
import RecipientsModal from "@/components/dashboard/modal/RecipientsModal";
import TransactionModal from "@/components/dashboard/modal/TransactionModal";
import TransferModal from "@/components/dashboard/modal/TransferModal";
import Footer from "@/components/dashboard/footer/Footer";
import NavBar from "@/components/dashboard/navBar/NavBar";
import Preloader from "@/components/dashboard/preloader/Preloader";
import { PaylioProvider } from "@/context/context";
import { Outlet } from "react-router-dom";

export default function WorkspaceLayout() {
  return (
    <PaylioProvider>
      <Preloader />
      <RecipientsModal />
      <TransferModal />
      <PurchasedModal />
      <CongratulationsModal />
      <AddCardModal />
      <CardModal />
      <TransactionModal />
      <AddRecipientsModal />
      <NavBar />
      <Outlet />
      <Footer />
    </PaylioProvider>
  );
}
